import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=4f4b4826&scoped=true&"
import script from "./BaseTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&id=4f4b4826&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b4826",
  null
  
)

export default component.exports